import styled from 'styled-components';
import { Paragraph } from '../../atoms';

export const StyledSplitPanelBody = styled.div``;

export const IconContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing(6)};
`;

export const Header = styled.h3`
  ${props => props.theme.typography.subheading2};
  margin: 0;
  text-transform: uppercase;
  @media ${props => props.theme.laptop} {
    ${props => props.theme.typography.subheading1};
  }
`;

export const Body = styled.div`
  ${Paragraph} {
    ${props => props.theme.typography.heading4};
    margin: ${props => props.theme.spacing(4, 0)};
    @media ${props => props.theme.laptop} {
      ${props => props.theme.typography.heading3};
    }
  }
`;
